import { captureException } from '@sentry/react'
import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	type HttpUpdateProPhotosListing,
	httpUpdateProPhotosListing
} from '@/features/service-vetting/http/services-vetting.http.ts'
import { ServiceProPhotos } from '@/features/service-vetting/types.ts'
import { errorHandler, parseAxiosPromise } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useUpdateProPhotosListing = (
	urlParams: HttpUpdateProPhotosListing['urlParams'],
	options?: UseMutationOptions<
		ServiceProPhotos,
		unknown,
		HttpUpdateProPhotosListing['payload']
	>
) => {
	const queryClient = useQueryClient()
	return useMutation({
		...options,
		mutationFn: (payload) =>
			parseAxiosPromise({
				axiosPromise: httpUpdateProPhotosListing({
					urlParams,
					payload,
					params: {
						responseType: 'extended'
					}
				}),
				responseShape: ServiceProPhotos,
				onZodError: captureException
			}),
		onError: (error) => errorHandler(error),
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.cancelQueries({
				queryKey: [QUERY_KEYS.SERVICE_PRO_PHOTOS, urlParams.serviceId]
			})
			queryClient.setQueriesData(
				{
					queryKey: [
						QUERY_KEYS.SERVICE_PRO_PHOTOS,
						urlParams.serviceId
					]
				},
				data
			)
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
